import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.data,
    class: "p-datatable-sm kn-table",
    dataKey: "field",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event)),
    globalFilterFields: _ctx.lovsManagementSimpleDatatableDescriptor.globalFilterFields,
    responsiveLayout: "stack",
    breakpoint: "960px",
    onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onPage($event)))
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
            placeholder: _ctx.$t('common.search'),
            badge: "0",
            "data-test": "search-input"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        class: "kn-truncated",
        field: "name",
        header: _ctx.$t('common.name')
      }, null, 8, ["header"]),
      _createVNode(_component_Column, {
        header: _ctx.$t('managers.lovsManagement.value')
      }, {
        body: _withCtx((slotProps) => [
          _createVNode(_component_RadioButton, {
            modelValue: _ctx.selectedValue,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedValue = $event)),
            name: "value",
            value: slotProps.data.name,
            onChange: _ctx.setSelectedValue
          }, null, 8, ["modelValue", "value", "onChange"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        header: _ctx.$t('common.description')
      }, {
        body: _withCtx((slotProps) => [
          _createVNode(_component_RadioButton, {
            modelValue: _ctx.selectedDescription,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedDescription = $event)),
            name: "description",
            value: slotProps.data.name,
            onChange: _ctx.setSelectedDescription
          }, null, 8, ["modelValue", "value", "onChange"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        header: _ctx.$t('managers.lovsManagement.visible')
      }, {
        body: _withCtx((slotProps) => [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.selectedVisible,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedVisible = $event)),
            name: "visible",
            value: slotProps.data.name,
            onChange: _ctx.setSelectedVisible
          }, null, 8, ["modelValue", "value", "onChange"])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["value", "filters", "globalFilterFields"]))
}